import Vue from 'vue';
import Component from 'vue-class-component';

// tslint:disable-next-line:no-var-requires
const Cookies = require('js-cookie');

interface Payload {
  [key: string]: string;
}

@Component
export default class Cookie extends Vue {
  public saveValue(payload: Payload, value: number | boolean | string): void {
    Cookies.set(this.cookieId(payload), String(value), { path: '/' });
  }

  public findString(payload: Payload): string {
    let value = '';
    if (this.shouldKeepValue()) {
      const v = Cookies.get(this.cookieId(payload));
      if (v !== undefined) {
        value = v;
      }
    } else {
      this.deleteValue(payload);
    }
    return value;
  }

  public findNumber(payload: Payload): number {
    let value = 0;
    if (this.shouldKeepValue()) {
      const v = Cookies.get(this.cookieId(payload));
      if (v !== undefined) {
        value = JSON.parse(v);
      }
    } else {
      this.deleteValue(payload);
    }
    return value;
  }

  public findBoolean(payload: Payload): boolean {
    let value = false;
    if (this.shouldKeepValue()) {
      const v = Cookies.get(this.cookieId(payload));
      if (v !== undefined) {
        value = JSON.parse(v);
      }
    } else {
      this.deleteValue(payload);
    }
    return value;
  }

  public findArray(payload: Payload): [] {
    let value = [];
    if (this.shouldKeepValue()) {
      const v = Cookies.get(this.cookieId(payload));
      if (v !== undefined) {
        value = JSON.parse(v);
      }
    } else {
      this.deleteValue(payload);
    }
    return value;
  }

  public findHash(payload: Payload): {} {
    let value = {};
    if (this.shouldKeepValue()) {
      const v = Cookies.get(this.cookieId(payload));
      if (v !== undefined) {
        value = JSON.parse(v);
      }
    } else {
      this.deleteValue(payload);
    }
    return value;
  }

  public deleteValue(payload: Payload): void {
    Cookies.remove(this.cookieId(payload), { path: '/' });
  }

  private cookieId(payload: Payload): string {
    const list = Object.values(payload);
    list.unshift(this.$route.path);
    return list.join('-');
  }

  private shouldKeepValue(): boolean {
    const arg = {} as any;
    const pair = window.location.search.substring(1).split('&');
    for (let i = 0; pair[i]; i++) {
      const kv = pair[i].split('=');
      arg[kv[0]] = kv[1];
    }
    return arg['keep'] === 'true';
  }
}
